module.exports = __webpack_public_path__ + "img/bar-chart-11.c8a522d5.svg";